import { useMemo } from "react";

import { ProgressBarContextProviderProps } from "../context/ProgressBarContextProvider";
import { BreakpointBuilder } from "../util/BreakpointBuilder";

export function useBreakpointBuilder({
  config,
  device,
  formatter,
}: ProgressBarContextProviderProps) {
  return useMemo(() => {
    return new BreakpointBuilder(config, device, formatter);
  }, [device, formatter]);
}
